/**
 * 项目孵化器接口（扩展⑦ 方向发现）。
 * 契约：
 *   GET  /teams/:id/ideas                     → IdeasViewDto
 *   POST /teams/:id/ideas {rawText}           → {idea}（201）
 *   POST /teams/:id/idea-votes {clusterKey}   → {voted:true}
 *   POST /teams/:id/idea-votes/remove {clusterKey} → {voted:false}
 *   POST /teams/:id/direction {clusterKey}    → {direction}（仅队长/admin）
 */
import { api } from './client.js';
import type { IdeaDto, IdeasViewDto, TeamDirectionDto } from './types.js';

const enc = encodeURIComponent;

export const incubatorApi = {
  view: (teamId: string): Promise<IdeasViewDto> => api.get<IdeasViewDto>(`/teams/${enc(teamId)}/ideas`),

  submit: (teamId: string, rawText: string): Promise<{ idea: IdeaDto }> =>
    api.post<{ idea: IdeaDto }>(`/teams/${enc(teamId)}/ideas`, { rawText }),

  vote: (teamId: string, clusterKey: string): Promise<{ voted: true }> =>
    api.post<{ voted: true }>(`/teams/${enc(teamId)}/idea-votes`, { clusterKey }),

  unvote: (teamId: string, clusterKey: string): Promise<{ voted: false }> =>
    api.post<{ voted: false }>(`/teams/${enc(teamId)}/idea-votes/remove`, { clusterKey }),

  choose: (teamId: string, clusterKey: string): Promise<{ direction: TeamDirectionDto }> =>
    api.post<{ direction: TeamDirectionDto }>(`/teams/${enc(teamId)}/direction`, { clusterKey }),
};
